import { render, staticRenderFns } from "./CircleMicrophoneIcon.vue?vue&type=template&id=372187d4&"
import script from "./CircleMicrophoneIcon.vue?vue&type=script&lang=js&"
export * from "./CircleMicrophoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports